import 'shepherd.js/dist/css/shepherd.css';
import { Global } from '@emotion/react';
import { offset } from '@floating-ui/dom';
import { type TourOptions } from 'shepherd.js';
import { styles } from './styles';

export const ShepherdTourOptions: TourOptions = {
  defaultStepOptions: {
    arrow: true,
    floatingUIOptions: {
      middleware: [offset({ mainAxis: 40 })],
    },
    modalOverlayOpeningPadding: 24,
    cancelIcon: {
      enabled: true,
    },
    scrollTo: { behavior: 'smooth', block: 'center' },
    classes: 'stena-recycling',
  },
  useModalOverlay: true,
};

export const ShepherdStyling = () => {
  return <Global styles={styles} />;
};
